export const ACTUAL_START_DATE = "actualStartDate";
export const ACTUAL_END_DATE = "actualEndDate";
export const PERCENTAGE = "completionPercentage";
export const TASK_STATUS = "actualStatus";
export const ACTUAL_DURATION = "actualDuration";

export const statusOption = [
  { label: "Draft", value: "DRAFT" },
  { label: "Active", value: "ACTIVE" },
  { label: "Completed", value: "COMPLETED" },
  { label: "On Hold", value: "ONHOLD" },
];
